const Ellipse = () => {
  return <div className='ellipse'></div>;
};
export default Ellipse;
